import { render, staticRenderFns } from "./add-node-overlay.vue?vue&type=template&id=12c39987&scoped=true&"
import script from "./add-node-overlay.vue?vue&type=script&lang=ts&"
export * from "./add-node-overlay.vue?vue&type=script&lang=ts&"
import style0 from "./add-node-overlay.vue?vue&type=style&index=0&id=12c39987&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12c39987",
  null
  
)

export default component.exports